// removed by extract-text-webpack-plugin
module.exports = {"colors":"\"../../../styles/variables.css\"","primary":"#56CCF2","wrapper":"_2ZFK03MpuV-8rkemfQDXpj","heading":"_2CC3qDSb44VYWsjTC1wX5r","footer":"_11MhbQtSMGgv389O1sLuXP","action":"_316DixyaLL43LyZQyGxkQY","redoLink":"_3pjwDztRB56zyps6DbMtn","locked":"_3EgwulGqw14cuORB_yOUCe"};


//////////////////
// WEBPACK FOOTER
// ./src/containers/Dashboard/components/ModulePopover.mod.css
// module id = 1630
// module chunks = 0